const template = `
<div class="uoe-container">
  <div class="uoe-content">
    <h2 id="uoe-consent-desc" class="uoe-heading"></h2>
      <p>
        Necessary cookies are on by default.
        <span class="consent-necessary-url"></span>
      </p>

      <h3 class="uoe-heading">Analytics cookies</h3>
      <p>
        We use analytics cookies so we can see how visitors use our website. This helps us to improve your experience.
        <span class="consent-performance-url"></span>
      </p>
      <div class="uoe-settings">
        <div class="uoe-check">
          <input type="radio" class="uoe-check-input" data-consent-choice
                 name="performance"
                 id="uoe-consent-setting-1"
                 value="yes"
          >
          <label class="uoe-check-label" for="uoe-consent-setting-1">I'm OK with analytics data being recorded</label>
        </div>
        <div class="uoe-check">
          <input type="radio" class="uoe-check-input" data-consent-choice
                 name="performance"
                 id="uoe-consent-setting-2"
                 value="no"
          >
          <label class="uoe-check-label" for="uoe-consent-setting-2">I do not want my website usage included in analytics data</label>
        </div>
      </div>

      <h3 class="uoe-heading">Marketing cookies</h3>
      <p>
        These cookies are set by our advertising partners to show you personalised ads for events and
        services you might be interested in.
        <span class="consent-adverts-url"></span>
      </p>
      <div class="uoe-settings">
        <div class="uoe-check">
          <input type="radio" class="uoe-check-input" data-consent-choice
                 name="advertising"
                 id="uoe-consent-setting-3"
                 value="yes"
          >
          <label class="uoe-check-label" for="uoe-consent-setting-3">I'm OK with personalised ads</label>
        </div>
        <div class="uoe-check">
          <input type="radio" class="uoe-check-input" data-consent-choice
                 name="advertising"
                 id="uoe-consent-setting-4"
                 value="no"
          >
          <label class="uoe-check-label" for="uoe-consent-setting-4">I do not want to see personalised ads</label>
        </div>
      </div>

      <p>You can always revisit these settings by clicking on the link at the bottom of all web pages.</p>

      <button type="button" class="uoe-btn uoe-btn-primary" data-consent-save>Save settings</button>
    </div>
  </div>
</div>
`

export default template
